//configures the DEV environment
export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyBFy8fUoel_uXlabY2MszfobozCsU_2Kzw",
    authDomain: "atlasity-io.firebaseapp.com",
    databaseURL: "https://atlasity-io.firebaseio.com",
    projectId: "atlasity-io",
    storageBucket: "atlasity-io.appspot.com",
    messagingSenderId: "788460982691",
    appId: "1:788460982691:web:aa7aed4b273b6812c3ca16",
    measurementId: "G-957WZR9EPG",
  },
};

